import React, { useState, useEffect } from 'react';
import './DemographicFilters.styles.scss';
import { toggleInArray } from "../../core/helpers";

function Option ({ id, label, isActive, setActive }) {
    const classList = ['filters__item'];
    if (isActive) {
        classList.push('filters__item--active');
    }
    return (
        <div
            onClick={setActive}
            className={classList.join(' ')}
        >
            {label}
        </div>
    )
}

function Filter ({ id, title, options, activeFilterIds, setActiveFilterIds }) {
    return (
        <div className="filters">
            <div className="filters__title">{title}</div>
            <div className="filters__items">
                {options.map(option => (
                    <Option
                        key={option.id}
                        {...option}
                        isActive={activeFilterIds.includes(option.id)}
                        setActive={() => setActiveFilterIds(toggleInArray(activeFilterIds, option.id))}
                    />
                ))}
            </div>
        </div>
    );
}

function DemographicFilters({ isOpened, close, data, activeFilterIds, setActiveFilterIds }) {
    const [localActiveFilterIds, setLocalActiveFilterIds] = useState([]);


    useEffect(() => {
        setLocalActiveFilterIds(activeFilterIds);
    }, [activeFilterIds, isOpened]);
    return (
        <div className={`demographic-filters ${isOpened ? 'demographic-filters--active' : ''}`}>
            <div className="demographic-filters__inner">
                <div className="demographic-filters__top">
                    <div className="demographic-filters__title">Demographic Filters</div>
                </div>
                <div className="demographic-filters__content">
                    {data.map((column, index) => (
                        <div key={index} className="demographic-filters__col">
                            {column.map(filter => (
                                <Filter
                                    key={filter.id}
                                    {...filter}
                                    activeFilterIds={localActiveFilterIds}
                                    setActiveFilterIds={setLocalActiveFilterIds}
                                />
                            ))}
                        </div>
                    ))}
                </div>
                <div className="demographic-filters__bottom">
                    <button
                        className="btn btn--secondary"
                        onClick={close}
                    >
                        cancel
                    </button>
                    <button
                        className="btn btn--primary"
                        onClick={() => setActiveFilterIds(localActiveFilterIds)}
                    >
                        apply
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DemographicFilters;